import api from "./api";

const get = async () => await api.get('userCategory/')

export default {get}
